import React from 'react';
import { PropTypes } from 'prop-types';
import { keys } from 'lodash';
import { StatusChip } from '@payer-admin-ui/components-v2/src/labels/StatusChip';
import { CREDIT_STATUS_COLORS } from '../CardsConstants';

const CreditStatusChip = ({ status }) => {
  return (
    <StatusChip
      text={status}
      color={CREDIT_STATUS_COLORS[status] ?? CREDIT_STATUS_COLORS.DEFAULT}
      style={{ fontSize: '14px' }}
    />
  );
};

CreditStatusChip.propTypes = {
  status: PropTypes.oneOf(keys(CREDIT_STATUS_COLORS)),
};

export { CreditStatusChip };
